module.exports = __webpack_public_path__ + "img/outofhome2.619b88fa.jpg";